module.exports = __webpack_public_path__ + "02_bob_gold.7f3676b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/02_bob_gold.png
// module id = FPHS
// module chunks = 0